<template>
  <div class="reservation-card" :class="{ 'w-100': isEntire, 'villa-mobile-width': isVillaLodging }" v-if="item">
    <!-- Villa Request Form - Inline Display -->
    <div v-if="showVillaRequestForm" class="villa-form-inline-container">
      <VillaRequestForm
        :lodging="lodging"
        :item="item"
        :from="from"
        :to="to"
        :user="user"
        :numberOfPeople="currentNumberOfPeople"
        :selectedRate="currentSelectedRate"
        :ratePerNight="currentRatePerNight"
        :conditions="currentConditions"
        @close="showVillaRequestForm = false"
        @request-submitted="handleRequestSubmitted"
      />
    </div>

    <!--KOEDIA-->
    <!--<div v-if="this.accomodationCode && !item.is_entire">-->
    <div v-if="this.accomodationCode && !showVillaRequestForm">
      <!--<div v-if="!this.roomAvailability || this.roomAvailability.options.length === 0 || isSearching" class="reservation-box">-->
      <div v-if="!priceOptions || priceOptions.length === 0 || isSearching" class="reservation-box"
        :class="{ 'full-width': bookButtonCaption === 'Indisponible' || bookButtonCaptionNotKoedia === 'Indisponible', 'normal-width': bookButtonCaption !== 'Indisponible' && bookButtonCaptionNotKoedia !== 'Indisponible' }">
        <div class="box-price box-price-no-search">
          <div class="box-middle d-flex">
            <button :disabled="disableButton" class="hortense-btn-primary" @click="$emit('expandCalendar');">
              {{ bookButtonCaption }}
            </button>
          </div>
        </div>
        <span
          v-if="(!this.roomAvailability || !normalizedRoomAvailability.options || normalizedRoomAvailability.options.length === 0) && this.searched && minNights > nights"
          class="raleway-reg-p11 mt-2 d-flex align-items-baseline justify-content-center" style="gap:4px;"
          :class="isPhone ? 'mb-2' : ''">
          <i class="fas fa-info-circle"></i>
          <div class="d-flex">Nombre de nuits minimum <span class="raleway-semi-p11 ml-1">{{ minNights }}</span></div>
        </span>
      </div>

      <div class="reservation-container" :class="{ 'full-width-reser-cont': !isEntire }" ref="reservationContainer"
        v-if="this.accomodationCode">
        <div class="tariff-slider-wrapper">
          <div class="tariff-slider" ref="slider">
            <div v-for="(priceOption, idx) in priceOptions" :key="idx" class="reservation-box"
              style="background: #fefefe;"
              :class="{ 'full-width': priceOptions && priceOptions.length == 1, 'normal-width': priceOptions && priceOptions.length > 1 }">
              <div class="box-price" style="border: none;">
                <div class="d-flex align-items-start justify-content-between">
                  <div class="d-flex flex-column align-items-start">
                    <h4 v-if="boardType(idx)" class="_sub_title_right-two" style="margin-bottom: 0px;">{{ boardType(idx)
                      == "Chambre seulement" ? 'DOUCE NUIT' : boardType(idx) == "Petit-déjeuner" || boardType(idx) ==
                        "Petit déjeuner inclus" || boardType(idx) == "Petit dejeuner inclus" ? 'DÉLICE AU RÉVEIL' :
                      boardType(idx) == "Demi-pension" || boardType(idx) == "Demi pension inclus" || boardType(idx) ==
                        "Demi-pension inclus" ? 'ESCAPADE GOURMANDE' : boardType(idx) == "Tout inclus" || boardType(idx)
                          == "Tout-inclus" ? 'PLAISIRS ILLIMITÉS' : boardType(idx) == "complète-pension" || boardType(idx)
                            == "complète pension inclus" || boardType(idx) == "complète-pension inclus" || boardType(idx) ==
                            "complet-pension" || boardType(idx) == "complet pension inclus" || boardType(idx) ==
                      "complet-pension inclus" || boardType(idx) == "Pension complete" ? 'ÉVASION CULINAIRE' : 'DOUCE NUIT'}}</h4>
                    <div class="conditions">
                      <p class="raleway-reg-p13" style="text-align: left; margin-bottom: 12px;">
                        {{ boardType(idx) }}
                      </p>
                      <p class="raleway-reg-p13" style="text-align: left; margin-bottom: 12px;">
                        {{ cancellationMessages[idx] }}
                      </p>
                      <p
                        v-if="priceOptions && priceOptions.length > 1 && contractRemark(idx)"
                        class="raleway-reg-p13"
                        style="text-align: left; margin-bottom: 12px;"
                      >
                        {{ contractRemark(idx) }}
                      </p>
                    </div>
                  </div>
                  <div class="price-row totall">
                    <p class="raleway-semi-p15 mb-0 text-nowrap" style="color: black;">{{ pricePerNightTtc(idx) }} EUR
                    </p>
                    <p class="raleway-reg-p13 mb-2">par nuit</p>
                  </div>
                </div>
                <hr class="mx-0 my-1" />
                <div class="d-flex align-items-center justify-content-between">
                  <div class="date_and_nights d-flex align-items-center justify-content-start">
                    <p class="raleway-reg-p13 text-capitalize mb-0">{{ formatDateFrench(from) }}.</p>
                    <img src="../../images/arrow-right-black.svg" class="mx-1" style="width: 13px;height: 13px;"
                      v-set-alt />
                    <p class="raleway-reg-p13 text-capitalize mb-0">{{ formatDateFrench(to) }}.</p>
                  </div>
                  <div class="nights-count d-flex align-items-center justify-content-end my-2">
                    <p class="raleway-reg-p13 mb-0">{{ nights }} nuit{{ nights > 1 ? 'ées' : '' }}</p>
                  </div>
                </div>
                <hr class="mx-0 my-1" />
                <div class="d-flex flex-column align-items-start my-2">
                  <CardDiscountBadges class="w-100" v-if="maxDiscountData" width="100%"
                    :lodging="{ lodging_discounts: [maxDiscountData] }" />
                  <div class="total-content mb-1">
                    <div class="d-flex flex-column align-items-start justify-content-start">
                      <p class="raleway-semi-p13 mb-2">TOTAL</p>
                      <p class="raleway-reg-p13">Taxes et frais compris</p>
                    </div>
                    <div class="d-flex flex-column align-items-end">
                      <div class="d-flex align-items-center justify-content-end mb-1" style="gap: 5px;"
                        v-if="discountPercentage > 0">
                        <div class="raleway-light-13 mb-0 discounted-amount text-light-gray">
                          <s>{{ totalTtc(idx) }}EUR</s>
                        </div>
                        <div class="raleway-semi-p15">
                          {{ (totalTtc(idx) - getDiscountedAmount(totalTtc(idx))).toFixed(2) }}EUR
                        </div>
                        <div class="discount-percentage raleway-medi-p12">
                          -{{ discountPercentage }}%
                        </div>
                      </div>
                      <p v-else class="raleway-semi-p15 mb-1" style="color: black;">{{ totalTtc(idx) }}EUR</p>
                      <button v-if="!lodging.is_entire && !selectMultipleRooms" :disabled="disableButton || isReserveProcessingForTariff(idx)" class="hortense-btn-primary"
                        style="width: 100%; text-align: center; border: none; cursor: pointer;" @click="sendInfo(idx)">
                        <i v-if="isReserveProcessingForTariff(idx)" class="fas fa-spinner fa-spin mr-2"></i>
                        {{ bookButtonCaption }}
                      </button>
                      <div v-else-if="!lodging.is_entire && selectMultipleRooms" class="tariff-qty-control d-flex flex-column align-items-end mt-2">
                        <div class="d-flex align-items-center justify-content-end">
                          <button class="qty-btn" @click="$emit('decrementTariff', { tariff: idx })" :disabled="getTariffQty(idx) <= 1">−</button>
                          <span class="qty-value mx-2">{{ getTariffQty(idx) }}</span>
                          <button
                            class="qty-btn"
                            @click="emitIncrementTariffKoedia(idx)"
                            :disabled="getTariffQty(idx) >= maxQtyForTariff(idx)">+</button>
                        </div>
                        <p class="raleway-reg-p13 mb-0 mt-1" :class="isPhone ? 'text-right' : ''" style="color: #dc3545;">Sélectionner le nombre de chambres</p>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex w-100 align-items-baseline" :class="[isPhone ? 'gap-1' : 'gap-2', isVillaLodging ? '' : 'justify-content-end']" v-if="lodging.is_entire">
                    <button v-if="isVillaLodging" class="hortense-btn-secondary text-nowrap"
                      style="width: 50%; text-align: center; border: 1px solid #2C5E4B; background: white; color: #2C5E4B; cursor: pointer;"
                      @click="handleMakeRequest()">
                      DEMANDER DES INFOS
                    </button>
                    <button :disabled="disableButton || isReserveProcessingForTariff(idx)" class="hortense-btn-primary"
                      style="width: 50% !important; text-align: center; border: none; cursor: pointer;" @click="sendInfo(idx)">
                      <i v-if="isReserveProcessingForTariff(idx)" class="fas fa-spinner fa-spin mr-2"></i>
                      {{ bookButtonCaption }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- NOT KOEDIA -->
    <div v-if="!this.accomodationCode && !showVillaRequestForm">
      <div v-if="!this.roomAvailabilityNotKoedia || !tariffsNotKoedia || tariffsNotKoedia.length === 0 || isSearching"
        class="reservation-box" style="width: 100% !important;">
        <div class="box-price box-price-no-search">
          <div class="box-middle d-flex">
            <button :disabled="disableButtonNotKoedia" class="hortense-btn-primary" @click="$emit('expandCalendar');">
              {{ bookButtonCaptionNotKoedia }}
            </button>
          </div>
        </div>
        <div
          v-if="(!this.roomAvailabilityNotKoedia || !tariffsNotKoedia || tariffsNotKoedia.length === 0) && this.searched && minNightsNew > nights && !hideMinNightsMessage"
          class="w-100 text-center">
          <p class="raleway-reg-p13"><i>Nombre de nuits minimum : {{ minNightsNew }}.</i></p>
        </div>
      </div>
      <div v-else class="reservation-container" :class="{ 'full-width-reser-cont': !isEntire }" ref="reservationContainer">
        <div class="tariff-slider-wrapper">
          <div class="tariff-slider" ref="slider">
            <div v-for="tariff in tariffsNotKoedia" :key="tariff" class="reservation-box"
              :class="{ 'full-width': tariffsNotKoedia && tariffsNotKoedia.length == 1 }" style="background: #fefefe;">
              <div v-if="pricePerNightTtcNotKoedia(tariff)" class="box-price" style="border: none;">
                <div class="d-flex align-items-start justify-content-between">
                  <div class="d-flex flex-column align-items-start">
                    <h4 v-if="getOptionFromHash(tariff)" class="_sub_title_right-two" style="margin-bottom: 0px;">{{
                      getOptionFromHash(tariff) }}</h4>
                    <div class="conditions">
                      <p v-if="getOptionFromHash(tariff) === 'DOUCE NUIT' && !hasAccommodationType(tariff)"
                        class="raleway-reg-p13" style="text-align: left; margin-bottom: 12px;">
                        {{ isEntire ? 'Logement entier' : 'Chambre seulement' }}
                      </p>

                      <p v-for="idx in tariff.split(',')" :key="idx" class="raleway-reg-p13"
                        style="text-align: left; margin: 4px 0 12px;"
                        v-if="!(lodging.type === 'Maison et Villa' && optionHash[idx] === 'Petit déjeuner non inclus')">
                        {{ optionHash[idx] }}
                      </p>
                      <p v-for="(message, idx) in cancellationMessages" :key="idx" class="raleway-reg-p13"
                        style="text-align: left; margin-bottom: 12px;">
                        {{ message }}
                      </p>
                      <p v-if="weeklyStayRuleLabel(tariff)" class="raleway-reg-p13"
                        style="text-align: left; margin-bottom: 12px;">
                        {{ weeklyStayRuleLabel(tariff) }}
                      </p>
                    </div>
                  </div>
                  <div class="price-row totall">
                    <p class="raleway-semi-p15 mb-0 text-nowrap" style="color: black;">{{ computedTariffPrices[tariff] }} EUR</p>
                    <p class="raleway-reg-p13 mb-2">par nuit</p>
                  </div>
                </div>
                <hr class="mx-0 my-1" />
                <div class="d-flex align-items-center justify-content-between">
                  <div class="date_and_nights d-flex align-items-center justify-content-start">
                    <p class="raleway-reg-p13 text-capitalize mb-0">{{ formatDateFrench(from) }}.</p>
                    <img src="../../images/arrow-right-black.svg" class="mx-1" style="width: 13px;height: 13px;"
                      v-set-alt />
                    <p class="raleway-reg-p13 text-capitalize mb-0">{{ formatDateFrench(to) }}.</p>
                  </div>
                  <div class="nights-count d-flex align-items-center justify-content-end my-2">
                    <p class="raleway-reg-p13 mb-0">{{ nights }} nuit{{ nights > 1 ? 'ées' : '' }}</p>
                  </div>
                </div>
                <hr class="mx-0 my-1" />
                <div class="d-flex flex-column align-items-start my-2">
                  <CardDiscountBadges class="w-100" v-if="maxDiscountData" width="100%"
                    :lodging="{ lodging_discounts: [maxDiscountData] }" />
                  <div v-if="houseHoldNotKoedia && houseHoldNotKoedia > 0"
                    class="d-flex justify-content-between align-items-center w-100 mb-2">
                    <p class="raleway-semi-p13 mb-0">Frais de ménage</p>
                    <p class="raleway-semi-p13 mb-0">{{ houseHoldNotKoedia }}EUR</p>
                  </div>
                  <div class="total-content mb-1">
                    <div class="d-flex flex-column align-items-start justify-content-start">
                      <p class="raleway-semi-p13 mb-2">TOTAL</p>
                      <p class="raleway-reg-p13">Taxes et frais compris</p>
                    </div>
                    <div class="d-flex flex-column align-items-end">
                      <div class="d-flex align-items-center justify-content-end mb-1" style="gap: 5px;"
                        v-if="discountPercentage > 0">
                        <div class="raleway-light-13 mb-0 discounted-amount text-light-gray">
                          <s>{{ (safeFloat(calculateDailyTotalNotKoedia(tariff)) + safeFloat(houseHoldNotKoedia)).toFixed(2) }}EUR</s>
                        </div>
                        <div class="raleway-semi-p15">
                          {{ (calculateDailyTotalNotKoedia(tariff) -
                            getDiscountedAmount(calculateDailyTotalNotKoedia(tariff)) +
                          safeFloat(houseHoldNotKoedia)).toFixed(2) }}EUR
                        </div>
                        <div class="discount-percentage raleway-medi-p12">
                          -{{ discountPercentage }}%
                        </div>
                      </div>
                      <p v-else class="raleway-semi-p15 mb-1" style="color: black;">{{
                        (parseFloat(calculateDailyTotalNotKoedia(tariff)) + safeFloat(houseHoldNotKoedia)).toFixed(2)
                        }}EUR</p>

                      <button v-if="!lodging.is_entire && !selectMultipleRooms" :disabled="disableButtonNotKoedia || isReserveProcessingForTariff(tariff)" class="hortense-btn-primary"
                        style="width: 100%; text-align: center; border: none; cursor: pointer;"
                        @click="sendInfo(tariff)">
                        <i v-if="isReserveProcessingForTariff(tariff)" class="fas fa-spinner fa-spin mr-2"></i>
                        {{ bookButtonCaptionNotKoedia }}
                      </button>
                      <div v-else-if="!lodging.is_entire && selectMultipleRooms" class="tariff-qty-control d-flex flex-column align-items-end mt-2">
                        <div class="d-flex align-items-center justify-content-end">
                          <button class="qty-btn" @click="$emit('decrementTariff', { tariff })" :disabled="getTariffQty(tariff) <= 1">−</button>
                          <span class="qty-value mx-2">{{ getTariffQty(tariff) }}</span>
                          <button
                            class="qty-btn"
                            @click="emitIncrementTariffNotKoedia(tariff)"
                            :disabled="getTariffQty(tariff) >= maxQtyForTariff(tariff)">+</button>
                        </div>
                        <p class="raleway-reg-p13 mb-0 mt-1" :class="isPhone ? 'text-right' : ''" style="color: #dc3545;">Sélectionner le nombre de chambres</p>
                      </div>
                    </div>
                  </div>
                  <div v-if="lodging.is_entire" class="d-flex w-100 align-items-baseline" :class="[isPhone ? 'gap-1' : 'gap-2', isVillaLodging ? '' : 'justify-content-end']">
                    <button v-if="isVillaLodging" class="hortense-btn-secondary text-nowrap"
                      style="width: 50%; text-align: center; border: 1px solid #2C5E4B; background: white; color: #2C5E4B; cursor: pointer;"
                      @click="handleMakeRequest()">
                      DEMANDER DES INFOS
                    </button>
                    <button :disabled="disableButtonNotKoedia || isReserveProcessingForTariff(tariff)" class="hortense-btn-primary"
                      style="width: 50% !important; text-align: center; border: none; cursor: pointer;" @click="sendInfo(tariff)">
                      <i v-if="isReserveProcessingForTariff(tariff)" class="fas fa-spinner fa-spin mr-2"></i>
                      {{ bookButtonCaptionNotKoedia }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <VillaInfoContainer v-if="lodging.is_entire" :lodging="this.lodging" />
          </div>
          <div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueImageSlider from "vue-image-slider";
import ModalRoomGalery from "../../components/modals/ModalRoomGalery.vue";
import CardDiscountBadges from "../shared/CardDiscountBadges.vue";
import VillaInfoContainer from "./VillaInfoContainer.vue";
import VillaRequestForm from "../forms/VillaRequestForm.vue";
import fetcher from "packs/shared/api.js";
import { ensureOspitaTrackingId } from "../../utils/reservationFlow";

export default {
  name: "ReservationCard",
  components: { VueImageSlider, ModalRoomGalery, CardDiscountBadges, VillaInfoContainer, VillaRequestForm },
  props: {
    minNights: Number,
    minNightsNew: Number,
    lodging: Object,
    koediaAvailability: Boolean,
    item: Object,
    searched: Boolean,
    isSearching: Boolean,
    nights: Number,
    from: Date,
    to: Date,
    roomAvailability: Object,
    roomAvailabilityNotKoedia: [],
    numberOfRoom: {
      default: 0,
      type: Number,
    },
    isEntire: Boolean,
    taxNotKoedia: Object,
    accomodationCode: Object,
    koediaFrom: String,
    koediaTo: String,
    tariffsNotKoedia: [],
    koediaSessionId: String,
    hideMinNightsMessage: Boolean,
    isVillaLodging: Boolean,
    user: Object,
    adults: {
      type: Number,
      default: 2
    },
    childAges: {
      type: Array,
      default: () => ([])
    },
    tariffQtys: {
      type: Object,
      default: () => ({})
    },
    maxRoomQty: {
      type: Number,
      default: 7
    },
    selectMultipleRooms: {
      type: Boolean,
      default: false
    },
    roomInventories: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      activeBulletIndex: 0,
      showMenu: false,
      currentIndex: 0,
      baseUrl: 'https://www.hortense.green',
      tvaNotKoedia: Number,
      houseHoldNotKoedia: 0,
      checkIn: null,
      checkOut: null,
      showVillaRequestForm: false,
      currentNumberOfPeople: 0,
      currentSelectedRate: 0,
      currentRatePerNight: 0,
      currentConditions: null,
      // imageArray: this.item.photos_keys,
      modalGallery: false,
      value: 3,
      subTotal: 0,
      gettingRateDetails: true,
      rateDetails: null,
      roomChoosedCount: 0,
      price: null,
      status: {
        getRateDetails: null,
      },
      cancellationMessages: {},
      preparedRateDetailsByTariff: {},
      image: `${this.item.photo_banner ??
        "https://images.unsplash.com/flagged/photo-1556438758-8d49568ce18e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1053&q=80"
        }`,
      pricingHash: {
        pn: 'breakfast_notinclude_pricing',
        pd: 'breakfast_include_pricing',
        cf: 'cancellation_free_pricing',
        nr: 'non_refundable_pricing',
        ai: 'all_inclusive_pricing',
        hp: 'half_pension_pricing',
        fp: 'full_pension_pricing',
        cc: 'cancel_condition_pricing'
      },
      optionHash: {
        pn: 'Petit déjeuner non inclus',
        pd: 'Petit déjeuner inclus',
        cf: 'Annulation gratuite',
        nr: 'Non remboursable',
        ai: 'Tout inclus',
        hp: 'Demi-pension',
        fp: 'Pension complète',
        cc: 'Annulation sous conditions',
        cs: 'Chambre seulement',
        t1: 'Tarif pour 1 personne',
        t2: 'Tarif pour 2 personnes',
        t3: 'Tarif pour 3 personnes',
        t4: 'Tarif pour 4 personnes',
        t5: 'Tarif pour 5 personnes',
        t6: 'Tarif pour 6 personnes',
        t7: 'Tarif pour 7 personnes',
        t8: 'Tarif pour 8 personnes',
        t9: 'Tarif pour 9 personnes',
        t10: 'Tarif pour 10 personnes',
        t11: 'Tarif pour 11 personnes',
        t12: 'Tarif pour 12 personnes',
        t13: 'Tarif pour 13 personnes',
        t14: 'Tarif pour 14 personnes',
        t15: 'Tarif pour 15 personnes',
        t16: 'Tarif pour 16 personnes',
        t17: 'Tarif pour 17 personnes',
        t18: 'Tarif pour 18 personnes',
        t19: 'Tarif pour 19 personnes',
        t20: 'Tarif pour 20 personnes',
        n7: '7 nuits minimum',
        n6: '6 nuits minimum',
        n5: '5 nuits minimum',
        n4: '4 nuits minimum',
        n3: '3 nuits minimum',
        n2: '2 nuits minimum'
      },
      optionHashTwo: {
        pn: 'DOUCE NUIT',
        pd: 'DÉLICE AU RÉVEIL',
        ai: 'PLAISIRS ILLIMITÉS',
        hp: 'ESCAPADE GOURMANDE',
        fp: 'ÉVASION CULINAIRE',
        cs: 'DOUCE NUIT',
        nr: 'DOUCE NUIT',
        // cc: 'DÉLICE AU RÉVEIL'
      },
      discountPercentage: 0,
      maxDiscountData: null,
      bookingInProgress: false,
      bookingInProgressKey: null
      //image: { backgroundImage: `url("${this.item.photo_banner ?? "https://images.unsplash.com/flagged/photo-1556438758-8d49568ce18e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1053&q=80" }")`}
    };
  },
  mounted() {
    console.log(this.item)
    console.log('tariffsNotKoedia');
    console.log(this.tariffsNotKoedia);
    this.equalizeCardHeights();
    if (this.houseHoldFeeNotKoedia && this.houseHoldFeeNotKoedia != 'undefined' && this.houseHoldFeeNotKoedia != null) {
      this.houseHoldNotKoedia = this.houseHoldFeeNotKoedia;
    }
    console.log('houseHoldNotKoedia:', this.houseHoldNotKoedia);

    window.addEventListener('resize', this.equalizeCardHeights);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.equalizeCardHeights);
  },
  watch: {
    from: {
      immediate: true,
      handler(val) {
        this.checkIn = val;
        if (val) {
          this.checkDiscountAvailable();
        }
      },
    },
    to: {
      immediate: true,
      handler(val) {
        this.checkOut = val;
        if (val) {
          this.checkDiscountAvailable();
        }
      },
    },
    numberOfRoom: {
      immediate: true,
      handler(val) {
        this.roomChoosedCount = val;
      },
    },
    priceOptions: {
      handler(newOptions) {
        if (newOptions) {
          newOptions.forEach((option, idx) => {
            this.isRefundable(idx);
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    isPhone() {
      console.log(this.tariffsNotKoedia);
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {

        return true;
      } else {
        return false;
      }
    },
    normalizedRoomAvailability() {
      return Array.isArray(this.roomAvailability)
        ? this.roomAvailability[0]
        : this.roomAvailability;
    },
    totalPhotos() {
      return this.item.photos_keys ? this.item.photos_keys.length : 0;
    },
    bookButtonCaption() {
      if (this.isSearching) {
        return "Recherche en cours...";
      } else if (!this.searched) {
        return "Rechercher";
      } else if (this.roomAvailability && this.normalizedRoomAvailability.options && this.normalizedRoomAvailability.options.length != 0) {
        return "Réserver";
      } else if (!this.roomAvailability || !this.normalizedRoomAvailability.options || this.normalizedRoomAvailability.options.length === 0) {
        return "Indisponible";
      }

    },
    bookButtonCaptionNotKoedia() {
      if (this.isSearching) {
        return "Recherche en cours...";
      } else if (!this.searched) {
        return "Rechercher";
      } else if (this.roomAvailabilityNotKoedia && this.tariffsNotKoedia && this.tariffsNotKoedia.length !== 0) {
        return "Réserver";
      } else if (!this.roomAvailabilityNotKoedia || !this.tariffsNotKoedia || this.tariffsNotKoedia.length === 0) {
        return "Indisponible";
      }
    },
    name() {
      return this.item.name;
    },
    total() {
      if (this.checkIn && this.checkOut && this.item.availabilities) {
        const dateCheckIn = this.item.availabilities.find(
          (el) => el.date === this.formatDate(this.checkIn)
        );
        const indexFrom = this.item.availabilities.indexOf(dateCheckIn);
        const dateCheckOut = this.item.availabilities.find(
          (el) => el.date === this.formatDate(this.checkOut)
        );
        const indexTo = this.item.availabilities.indexOf(dateCheckOut);
        const sum = this.item.availabilities
          .slice(indexFrom, indexTo + 1)
          .reduce((acc, current) => acc + current.pricing, 0);
        return sum * this.numberOfRoom;
      }
    },
    isAvailable() {
      return this.roomAvailability;
    },
    disableButton() {
      return (this.searched && (!this.isAvailable || !this.normalizedRoomAvailability
        .options || this.normalizedRoomAvailability.options.length === 0)) || this.isSearching;
    },
    disableButtonNotKoedia() {
      return (this.searched && (!this.roomAvailabilityNotKoedia || !this.tariffsNotKoedia || this.tariffsNotKoedia.length === 0)) || this.isSearching;
    },
    priceOptions() {
      if (this.isAvailable && this.roomAvailability) {
        console.log('DEBUG priceOptions');
        console.log(this.roomAvailability);

        const roomAvailability = Array.isArray(this.roomAvailability)
          ? this.roomAvailability[0]
          : this.roomAvailability;

        if (!roomAvailability || !roomAvailability.options) {
          return [];
        }

        console.log(roomAvailability.options);

        const uniqueOptions = roomAvailability.options.reduce((acc, current) => {
          if (!acc.some(option => option.room_id === current.room_id)) {
            acc.push(current);
          }
          return acc;
        }, []);

        return uniqueOptions;
      }
      return [];
    },
    computedTariffPrices() {
      if (this.roomAvailabilityNotKoedia && this.tariffsNotKoedia && this.tariffsNotKoedia.length) {
        return this.tariffsNotKoedia.reduce((acc, tariff) => {
          // Calculate daily total for this tariff
          let from = this.toDate(this.koediaFrom);
          let to = this.toDate(this.koediaTo);

          let currentDate = new Date(from);
          let dailyTotal = 0;
          let dayCount = 0;

          // Iterate through each day and sum the tariffs
          while (currentDate < to) {
            const dateStr = this.formatDateForKoedia(currentDate);
            const dailyTariff = this.roomAvailabilityNotKoedia.find(
              (el) => el.tariff === tariff && el.date === dateStr
            );

            if (dailyTariff) {
              const pricing_unit = dailyTariff.tariff_price;
              const tva_rate = this.taxNotKoedia?.tva_rate ?? 0;
              const tourist_tax = this.taxNotKoedia?.tourist_tax ?? 0;
              let adult_num = this.adults ? this.adults : 2;

              const tvaNotKoedia = pricing_unit * (tva_rate / 100);
              dailyTotal += pricing_unit + tvaNotKoedia + (tourist_tax * adult_num);
              dayCount++;
            }

            currentDate.setDate(currentDate.getDate() + 1);
          }

          // If we found daily data, use the total; otherwise fall back to single tariff
          if (dayCount > 0) {
            acc[tariff] = (dailyTotal / dayCount).toFixed(2); // Average per night for display
          } else {
            const pricing_unitt = this.roomAvailabilityNotKoedia.find((el) => el.tariff === tariff);
            if (pricing_unitt) {
              const pricing_unit = pricing_unitt.tariff_price;
              const tva_rate = this.taxNotKoedia?.tva_rate ?? 0;
              const tourist_tax = this.taxNotKoedia?.tourist_tax ?? 0;
              let adult_num = this.adults ? this.adults : 2;

              const tvaNotKoedia = pricing_unit * (tva_rate / 100);
              acc[tariff] = (pricing_unit + tvaNotKoedia + (tourist_tax * adult_num)).toFixed(2);
            }
          }
          return acc;
        }, {});
      }
      return {};
    },
    houseHoldFeeNotKoedia() {
      if (this.roomAvailabilityNotKoedia && this.roomAvailabilityNotKoedia.length > 0) {
        // Get house_hold_fee from the first availability item or find it in the data structure
        const firstAvailability = this.roomAvailabilityNotKoedia[0];
        return firstAvailability.house_hold_fee || 0;
      }
      return 0;
    }
  },
  methods: {
    /**
     * Find matching inventory for current room.
     * Tries koedia_room_id first, then room name fallback.
     */
    getCurrentRoomInventory() {
      if (!this.roomInventories) return null;

      const roomKoediaRoomId = this.item?.koedia_room_id ? String(this.item.koedia_room_id).toLowerCase().trim() : '';
      const candidates = [
        roomKoediaRoomId,
        this.item?.koedia_room_name,
        this.item?.name,
        this.roomAvailability?.room_name,
      ]
        .filter(Boolean)
        .map((v) => String(v).toLowerCase().trim());

      if (!candidates.length) return null;

      for (const key in this.roomInventories) {
        const inv = this.roomInventories[key];
        const invName = inv?.name ? String(inv.name).toLowerCase().trim() : null;
        if (invName && candidates.includes(invName)) {
          return inv;
        }
      }

      return null;
    },

    getAvailabilityOptionRoomId(option) {
      return String(option?.processed_room_id ?? option?.koedia_room_id ?? option?.room_id ?? '').trim();
    },

    /**
     * Match option tariff code with inventory tariff code and return min_night_count.
     */
    getTariffMinNightCountFromInventory(optionTariffCode) {
      if (!optionTariffCode) return null;

      const inventory = this.getCurrentRoomInventory();
      if (!inventory || !inventory.tariffs) return null;

      const normalizedOptionTariff = String(optionTariffCode).toLowerCase().trim();
      const matchedTariffCode = Object.keys(inventory.tariffs).find(
        (code) => String(code).toLowerCase().trim() === normalizedOptionTariff
      );

      if (!matchedTariffCode) return null;

      const minNight = Number(inventory.tariffs[matchedTariffCode]?.min_night_count);
      return Number.isFinite(minNight) && minNight > 0 ? minNight : null;
    },

    /**
     * Validate selected nights against matched tariff min_night_count.
     */
    validateTariffMinNightsFromInventory(optionTariffCode, nights) {
      const minNights = this.getTariffMinNightCountFromInventory(optionTariffCode);
      if (!minNights) return true;
      return Number(nights) >= minNights;
    },

    weeklyStayRuleLabel(tariff) {
      const m = {
        sat_to_sat: "Du samedi au samedi",
        fri_to_fri: "Du vendredi au vendredi",
        sun_to_sun: "Du dimanche au dimanche",
      };
      
      if (this.roomAvailabilityNotKoedia && this.roomAvailabilityNotKoedia.length) {
        const availability = this.roomAvailabilityNotKoedia.find(el => el.tariff === tariff);
        return m[availability?.weekly_stay_rule] || "";
      }
      return "";
    },
    hasAccommodationType(tariff) {
      if (!tariff) return false

      return tariff
        .split(',')
        .some(idx => {
          const value = this.optionHash[idx]
          return value === 'Logement entier' || value === 'Chambre seulement'
        })
    },
    safeFloat(value) {
      const num = parseFloat(value);
      return isNaN(num) ? 0 : num;
    },
    slugify(str) {
      return str
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .toLowerCase();
    },
    scrollLeft() {
      this.$refs.slider.scrollBy({ left: -320, behavior: 'smooth' });
    },
    scrollRight() {
      this.$refs.slider.scrollBy({ left: 320, behavior: 'smooth' });
    },
    setActiveBullet(index) {
      this.activeBulletIndex = index;
      const reservationContainer = this.$refs.reservationContainer;
      const card = reservationContainer.children[index];
      if (card) {
        card.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center"
        });
      }
    },
    equalizeCardHeights() {
      this.$nextTick(() => {
        const container = this.$refs.reservationContainer;
        if (container) {
          const boxes = container.querySelectorAll('.reservation-box');
          let maxHeight = 0;

          // Reset heights to auto to recalculate properly
          boxes.forEach((box) => {
            box.style.height = 'auto';
          });

          // Calculate the maximum height
          boxes.forEach((box) => {
            maxHeight = Math.max(maxHeight, box.offsetHeight);
          });

          // Apply the maximum height to all cards
          boxes.forEach((box) => {
            box.style.height = `${maxHeight}px`;
          });
        }
      });
    },
    getOptionFromHash(tariff) {
      const keys = tariff.split(',');
      if (this.optionHashTwo[keys[0]]) {
        return this.optionHashTwo[keys[0]];
      }
      if (keys[1] && this.optionHashTwo[keys[1]]) {
        return this.optionHashTwo[keys[1]];
      }
      if (keys[2] && this.optionHashTwo[keys[2]]) {
        return this.optionHashTwo[keys[2]];
      }
      return 'DOUCE NUIT';
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    getPhotoUrl(index) {
      if (!this.item?.photos_keys || this.item.photos_keys.length === 0) {
        return (
          this.item?.photo_banner ||
          "https://images.unsplash.com/flagged/photo-1556438758-8d49568ce18e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1053&q=80"
        );
      }
      return this.item.photos_keys[index] || this.item.photos_keys[0];
    },
    nextSlide() {
      if (this.currentIndex < this.totalPhotos - 1) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0;
      }
    },
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = this.totalPhotos - 1;
      }
    },
    displayCalendar() {
      // ???
    },
    pricePerNightTtc(idx) {
      console.log('idx', idx)
      console.log('this.priceOptions', this.priceOptions)
      if (this.priceOptions && this.priceOptions[idx]) {
        console.log('this.priceOptions', this.priceOptions[idx])
        console.log('this.priceOptions', this.priceOptions[idx].room_price)
        return this.priceOptions[idx].room_price.per_day.rack;
      }
      return null;
    },
    totalTtc(idx) {
      if (this.priceOptions && this.priceOptions[idx]) {
        return this.priceOptions[idx].room_price.total.rack.toFixed(2);
      }
      return null;
    },
    formatDateKoedia(date) {
      if (date.includes('-') || !date) {
        return date;
      }
      const dateBits = date.split('/');
      return `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}`;
    },
    getReservationState() {
      try {
        return JSON.parse(localStorage.getItem('reservationState')) || {};
      } catch (error) {
        return {};
      }
    },
    updateReservationStateFromKoediaRefresh({ koediaSessionId }) {
      const trackingId = ensureOspitaTrackingId();
      const state = this.getReservationState();

      localStorage.setItem('reservationState', JSON.stringify({
        ...state,
        koediaSessionId: koediaSessionId || state.koediaSessionId || this.koediaSessionId,
        koediaFrom: state.koediaFrom || this.koediaFrom,
        koediaTo: state.koediaTo || this.koediaTo,
        from: state.from || this.koediaFrom,
        to: state.to || this.koediaTo,
        ospita_tracking_id: trackingId,
      }));

      return trackingId;
    },
    getReservationChildAges() {
      const state = this.getReservationState();
      const storedChildAges = state?.children_ages ?? state?.childAges;

      if (Array.isArray(storedChildAges)) {
        return storedChildAges.filter((age) => age !== null && age !== undefined && age !== '');
      }

      if (Array.isArray(this.childAges)) {
        return this.childAges.filter((age) => age !== null && age !== undefined && age !== '');
      }

      return [];
    },
    getReservationChildrenCount() {
      const state = this.getReservationState();
      const fromState = Number.parseInt(state?.childs, 10);
      if (Number.isFinite(fromState) && fromState > 0) {
        return fromState;
      }

      const fromAges = this.getReservationChildAges().length;
      if (fromAges > 0) {
        return fromAges;
      }

      return 0;
    },
    hasMissingChildAgesSelection() {
      const childrenCount = this.getReservationChildrenCount();
      if (childrenCount <= 0) return false;

      return this.getReservationChildAges().length < childrenCount;
    },
    emitOpenGuestModalIfNeeded() {
      if (!this.hasMissingChildAgesSelection()) return false;

      this.$emit('open-guest-modal');
      return true;
    },
    formatDateFrench(date) {
      const options = { weekday: 'long', day: 'numeric', month: 'short' };
      const dateObj = new Date(date);
      return dateObj.toLocaleDateString('fr-FR', options);
    },
    async getRateDetails(idx) {
       if (!this.accomodationCode) return null;

       this.gettingRateDetails = true;
       try {
         this.koediaFrom = await this.formatDateKoedia(this.koediaFrom);
         this.koediaTo = await this.formatDateKoedia(this.koediaTo);

         // Validate by matching option tariff code with inventory tariff code
         if (this.priceOptions[idx] && this.nights) {
           const optionTariffCode = this.priceOptions[idx]?.tariff;
           const isValidNights = this.validateTariffMinNightsFromInventory(optionTariffCode, this.nights);

           if (!isValidNights) {
             const minNights = this.getTariffMinNightCountFromInventory(optionTariffCode);
             return {
               isFullyRefundable: false,
               deadline: null,
               cancellationItems: [],
               rawRateDetails: null,
               validationError: `Cette tarification nécessite un minimum de ${minNights} nuit${minNights > 1 ? 's' : ''}.`
             };
           }
         }

         const childAges = this.getReservationChildAges();

         const response = await fetcher.post(`/lodgings/${this.lodging.slug}/get_rate_details`, {
           koedia_session_id: this.koediaSessionId,
           koedia_room_id: this.priceOptions[idx].room_id,
           start: this.koediaFrom,
           end: this.koediaTo,
           children: childAges.length,
           children_ages: childAges,
           ospita_tracking_id: ensureOspitaTrackingId(),
         });

         this.rateDetails = response.data.get_rate_details_response.res_get_rate_details;
         if (!this.priceOptions[idx]?.refundable) return null;

        // Support both object and array policy formats.
        const rawPolicies = this.rateDetails?.cancellation_fees_policy;
        const policies = (Array.isArray(rawPolicies) ? rawPolicies : [rawPolicies]).filter(Boolean);

        // Keep only policies that actually have a fee amount.
        const policiesWithFee = policies.filter((policy) => {
          const rackFee = Number(policy?.amount?.['@rack']);
          return Number.isFinite(rackFee) && rackFee > 0;
        });

        // No fee policies => cancellation is free.
        if (!policiesWithFee.length) {
          return {
            isFullyRefundable: true,
            deadline: null,
            cancellationItems: this.buildCancellationItemsFromRateDetails(this.rateDetails, idx),
            rawRateDetails: this.rateDetails,
          };
        }

        // For before_checkin policies, free cancellation ends at max to_day.
        const daysBeforeCheckinList = policiesWithFee
          .filter((policy) => {
            const ref = String(policy?.from_day?.['@ref'] || policy?.ref || 'before_checkin').toLowerCase();
            return ref !== 'after_booking';
          })
          .map((policy) => Number(policy?.to_day))
          .filter((day) => Number.isFinite(day));

        if (daysBeforeCheckinList.length) {
          const maxDaysBeforeCheckin = Math.max(...daysBeforeCheckinList);
          const checkinDate = new Date(this.koediaFrom);
          checkinDate.setDate(checkinDate.getDate() - maxDaysBeforeCheckin);

          const day = String(checkinDate.getDate()).padStart(2, '0');
          const month = String(checkinDate.getMonth() + 1).padStart(2, '0');
          const year = checkinDate.getFullYear();

          return {
            isFullyRefundable: maxDaysBeforeCheckin > 0,
            deadline: `${day}-${month}-${year}`,
            cancellationItems: this.buildCancellationItemsFromRateDetails(this.rateDetails, idx),
            rawRateDetails: this.rateDetails,
          };
        }

        // after_booking only: free window lasts until the first fee day.
        const afterBookingDaysList = policiesWithFee
          .map((policy) => Number(policy?.from_day))
          .filter((day) => Number.isFinite(day));

        if (!afterBookingDaysList.length) {
          return {
            isFullyRefundable: false,
            deadline: null,
            cancellationItems: this.buildCancellationItemsFromRateDetails(this.rateDetails, idx),
            rawRateDetails: this.rateDetails,
          };
        }

        const firstFeeDayAfterBooking = Math.min(...afterBookingDaysList);
        const bookingDate = new Date();
        bookingDate.setDate(bookingDate.getDate() + firstFeeDayAfterBooking);

        const day = String(bookingDate.getDate()).padStart(2, '0');
        const month = String(bookingDate.getMonth() + 1).padStart(2, '0');
        const year = bookingDate.getFullYear();

        return {
          isFullyRefundable: firstFeeDayAfterBooking > 0,
          deadline: `${day}-${month}-${year}`,
          cancellationItems: this.buildCancellationItemsFromRateDetails(this.rateDetails, idx),
          rawRateDetails: this.rateDetails,
        };
      } catch (e) {
        this.status.getRateDetails = false;
        console.log("Failed getRateDetails");
        console.log(e);
        throw e;
      }
    },
    pricePerNightTtcNotKoedia(tariff) {

      if (this.roomAvailabilityNotKoedia && this.roomAvailabilityNotKoedia.length !== 0) {
        console.log('this.roomAvailabilityNotKoedia', this.roomAvailabilityNotKoedia);
        console.log('tariff', tariff);

        const pricing_unitt = this.roomAvailabilityNotKoedia.find((el) => el.tariff === tariff);
        if (!pricing_unitt) {
          console.error(`No matching tariff found for: ${tariff}`);
          return null;
        }

        const pricing_unit = pricing_unitt.tariff_price;
        const tva_rate = this.taxNotKoedia?.tva_rate ?? 0;
        const tourist_tax = this.taxNotKoedia?.tourist_tax ?? 0;
        let adult_num = this.adults ? this.adults : 2;

        // Per-night price: base + TVA + (tourist tax per adult)
        // This way: pricePerNight * nights = total
        const tvaNotKoedia = pricing_unit * (tva_rate / 100);
        console.log('tvaNotKoedia', tvaNotKoedia)

        return (pricing_unit + tvaNotKoedia + (tourist_tax * adult_num)).toFixed(2);
      }

      return null;
    },
    priceTvaNotKoedia(tariff) {

      if (this.roomAvailabilityNotKoedia && this.roomAvailabilityNotKoedia.length !== 0) {

        const pricing_unitt = this.roomAvailabilityNotKoedia.find((el) => el.tariff === tariff);
        if (!pricing_unitt) {
          console.error(`No matching tariff found for: ${tariff}`);
          return null;
        }

        const pricing_unit = pricing_unitt.tariff_price;
        const tva_rate = this.taxNotKoedia?.tva_rate ?? 0;

        // Per-unit TVA (not multiplied by nights here - that happens in totalTtcNotKoedia)
        const tvaNotKoedia = pricing_unit * (tva_rate / 100);
        console.log('tvaNotKoedia', tvaNotKoedia)

        return tvaNotKoedia;
      }

      return null;
    },
    toDate(date) {
      let d = new Date(date);
      d.setHours(12, 0, 0, 0);
      return d;
    },
    getCurrentNights() {
      const from = this.toDate(this.koediaFrom);
      const to = this.toDate(this.koediaTo);
      const nights = Math.ceil((to - from) / (1000 * 60 * 60 * 24));
      return isNaN(nights) || nights <= 0 ? 1 : nights;
    },
    taxValueTotal() {
      const touristTax = this.taxNotKoedia?.tourist_tax ?? 0;
      const adultNum = this.adults ? parseInt(this.adults) : 2;
      return parseFloat((touristTax * adultNum * this.getCurrentNights()).toFixed(2));
    },
    totalHtValueKoedia(idx) {
      const total = parseFloat(this.totalTtc(idx));
      const tvaRate = this.taxNotKoedia?.tva_rate ?? 0;
      if (isNaN(total)) return 0;
      return parseFloat((total / (1 + (tvaRate / 100))).toFixed(2));
    },
    tvaValueKoedia(idx) {
      const total = parseFloat(this.totalTtc(idx));
      const ht = this.totalHtValueKoedia(idx);
      if (isNaN(total)) return 0;
      return parseFloat((total - ht).toFixed(2));
    },
    priceHtNotKoedia(tariff) {
      if (this.roomAvailabilityNotKoedia && this.roomAvailabilityNotKoedia.length != 0) {
        return this.roomAvailabilityNotKoedia.find((el) => el.tariff === tariff).tariff_price;
      }
      return null;
    },
    totalTtcNotKoedia(tariff) {
      console.log('tariff', tariff);
      console.log('this.roomAvailabilityNotKoedia', this.roomAvailabilityNotKoedia);

      if (this.roomAvailabilityNotKoedia && this.roomAvailabilityNotKoedia.length !== 0) {
        let from = this.toDate(this.koediaFrom);
        let to = this.toDate(this.koediaTo);
        console.log("From:", from, "To:", to);

        const nights = Math.ceil((to - from) / (1000 * 60 * 60 * 24)) || 1;

        // Get per-night price which already includes: base + TVA + (tourist_tax * adults)
        const pricePerNight = parseFloat(this.pricePerNightTtcNotKoedia(tariff));

        // Total = per-night price × nights
        // NOTE: This assumes a flat rate per night. For variable daily tariffs,
        // you would need to iterate through each day and sum individual daily prices
        const total = pricePerNight * nights;
        return total.toFixed(2);
      }

      return null;
    },
    calculateDailyTotalNotKoedia(tariff) {
      // This method calculates total by summing individual daily tariffs
      // Use this if your backend provides daily breakdown of prices
      console.log('tariff', tariff);
      console.log('this.roomAvailabilityNotKoedia', this.roomAvailabilityNotKoedia);

      if (this.roomAvailabilityNotKoedia && this.roomAvailabilityNotKoedia.length !== 0) {
        let from = this.toDate(this.koediaFrom);
        let to = this.toDate(this.koediaTo);

        let currentDate = new Date(from);
        let dailyTotal = 0;

        // Iterate through each day and sum the tariffs
        while (currentDate < to) {
          const dateStr = this.formatDateForKoedia(currentDate);
          // Find the tariff for this specific date if available
          // This assumes your roomAvailabilityNotKoedia has daily breakdown
          const dailyTariff = this.roomAvailabilityNotKoedia.find(
            (el) => el.tariff === tariff && el.date === dateStr
          );

          if (dailyTariff) {
            const pricing_unit = dailyTariff.tariff_price;
            const tva_rate = this.taxNotKoedia?.tva_rate ?? 0;
            const tourist_tax = this.taxNotKoedia?.tourist_tax ?? 0;
            let adult_num = this.adults ? this.adults : 2;

            const tvaNotKoedia = pricing_unit * (tva_rate / 100);
            dailyTotal += pricing_unit + tvaNotKoedia + (tourist_tax * adult_num);
          }

          currentDate.setDate(currentDate.getDate() + 1);
        }

        return dailyTotal.toFixed(2);
      }

      return null;
    },
    htValueTotalNotKoedia(tariff) {
      if (!(this.roomAvailabilityNotKoedia && this.roomAvailabilityNotKoedia.length)) {
        return 0;
      }

      let from = this.toDate(this.koediaFrom);
      let to = this.toDate(this.koediaTo);
      let currentDate = new Date(from);
      let dailyHtTotal = 0;
      let hasDailyData = false;

      while (currentDate < to) {
        const dateStr = this.formatDateForKoedia(currentDate);
        const dailyTariff = this.roomAvailabilityNotKoedia.find(
          (el) => el.tariff === tariff && el.date === dateStr
        );

        if (dailyTariff) {
          dailyHtTotal += parseFloat(dailyTariff.tariff_price || 0);
          hasDailyData = true;
        }

        currentDate.setDate(currentDate.getDate() + 1);
      }

      if (!hasDailyData) {
        const priceHt = parseFloat(this.priceHtNotKoedia(tariff));
        dailyHtTotal = (isNaN(priceHt) ? 0 : priceHt) * this.getCurrentNights();
      }

      return parseFloat(dailyHtTotal.toFixed(2));
    },
    tvaValueTotalNotKoedia(tariff) {
      const tvaRate = this.taxNotKoedia?.tva_rate ?? 0;
      const htTotal = this.htValueTotalNotKoedia(tariff);
      return parseFloat((htTotal * (tvaRate / 100)).toFixed(2));
    },
    getSelectedPriceOptionFeeNotKoedia(tariff) {
      if (!(this.roomAvailabilityNotKoedia && this.roomAvailabilityNotKoedia.length)) {
        return null;
      }
      const matched = this.roomAvailabilityNotKoedia.find(function(el) {
        return el.tariff === tariff;
      });
      return matched && matched.tariff_cancel_feed ? matched.tariff_cancel_feed : null;
    },
    getBoardTypeNotKoedia(tariff) {
      if (!tariff || !tariff.split) return '';
      const keys = tariff.split(',');
      const boardKeys = ['pn', 'pd', 'ai', 'hp', 'fp', 'cs'];
      const matchedKey = keys.find((key) => boardKeys.includes(key));
      return matchedKey ? (this.optionHash[matchedKey] || '') : '';
    },
    async isRefundable(idx) {
      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString('fr-FR');
      if (this.priceOptions && this.priceOptions[idx]) {
        try {
          const cancelDetails = await this.getRateDetails(idx);
          let message = "Non annulable";
          
          if (this.priceOptions[idx].refundable) {
            if (cancelDetails?.isFullyRefundable) {
              if (cancelDetails?.deadline) {
                message = `Annulation gratuite avant le ${cancelDetails.deadline}`;
              } else {
                message = "Annulation gratuite";
              }
            } else if (cancelDetails?.deadline) {
              message = `Annulations sous conditions avant le ${cancelDetails.deadline}`;
            } else {
              message = "Annulations sous conditions";
            }
          }
          
          this.$set(this.cancellationMessages, idx, message);

          const selectedFee = this.priceOptions[idx]?.tariff_cancel_feed || null;
          this.$set(this.preparedRateDetailsByTariff, idx, {
            cancellationItems: Array.isArray(cancelDetails?.cancellationItems) ? cancelDetails.cancellationItems : [],
            selectedPriceOptionFee: selectedFee,
            rawRateDetails: cancelDetails?.rawRateDetails || null,
          });
        } catch (e) {
          console.log('Failed to get rate details:', e);
          this.$set(this.cancellationMessages, idx, "");
        }
      }
    },
    decodeHtmlEntities(value) {
      if (!value || typeof value !== 'string') return '';
      if (typeof document === 'undefined') return value;
      const txt = document.createElement('textarea');
      txt.innerHTML = value;
      return txt.value;
    },
    contractRemark(idx) {
      const raw = this.priceOptions?.[idx]?.contract_remark;
      if (!raw || typeof raw !== 'string') return '';

      const decoded = this.decodeHtmlEntities(raw).replace(/\r\n/g, '\n').trim();
      if (!decoded) return '';

      const lines = decoded
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line && !/Frais inclus\s*:/i.test(line));

      if (!lines.length) return '';

      lines[0] = lines[0].replace(/^\s*\[[^\]]+\]\s*/u, '').trim();

      return lines.filter(Boolean).join(': ');
    },
    boardType(idx) {
      console.log('idx', idx)
      console.log('this.priceOptions', this.priceOptions)
      if (!this.priceOptions || !this.priceOptions[idx]) {
        return null;
      }
      const option = this.priceOptions[idx];
      const board = option?.board;

      if (board && typeof board === 'object') {
        return Object.values(board)[0];
      }

      return null;
    },
    personDetails(idx) {
      if (this.item) {
        const children = parseInt(this.priceOptions[idx].children);
        const adults = parseInt(this.priceOptions[idx].adults);
        const totalPeople = children + adults;
        const personneSuffix = totalPeople > 1 ? "personnes" : "personne";
        return `Tarif pour ${totalPeople} ${personneSuffix}`;
      }
    },
    personsAmount(idx) {
      if (this.item) {
        const children = parseInt(this.priceOptions[idx].children);
        const adults = parseInt(this.priceOptions[idx].adults);
        const childrenAmount = children > 1 ? this.priceOptions[idx].children + " Enfants" : this.priceOptions[idx].children + " Enfant";
        const adultAmount = adults > 1 ? this.priceOptions[idx].adults + " Adultes" : this.priceOptions[idx].adults + " Adultes";
        return `(${adultAmount}, ${childrenAmount})`;
      }
    },
    SeeMoreService(e) {
      e.preventDefault();
      this.value += 3;
    },
    SeeLessService(e) {
      e.preventDefault();
      this.value = 3;
    },
    showModalGallery() {
      this.modalGallery = true;
      this.$nextTick(() => {
        this.modalGallery = true;
      });
    },

    formatCapacity(data) {
      if (data.length >= 1) {
        return `${data} personne`;
      } else {
        return `${data} personnes`;
      }
    },
    seeMore() {
      console.log(this.item);
    },
    emitIncrementTariffKoedia(idx) {
      this.$emit('incrementTariff', {
        tariff: idx,
        totalPrice: this.discountPercentage > 0
          ? parseFloat((this.totalTtc(idx) - this.getDiscountedAmount(this.totalTtc(idx))).toFixed(2))
          : parseFloat(this.totalTtc(idx)),
        pricePerNight: this.pricePerNightTtc(idx),
        cancellationConditions: this.cancellationMessages[idx] || '',
        boardType: this.boardType(idx) || '',
        htValueTotal: this.totalHtValueKoedia(idx),
        tvalTotal: this.tvaValueKoedia(idx),
        taxTotal: this.taxValueTotal(),
        selectedPriceOptionFee: this.priceOptions && this.priceOptions[idx] ? this.priceOptions[idx].tariff_cancel_feed || null : null,
        houseHold: 0,
        koediaRoomAvailability: this.priceOptions && this.priceOptions[idx] ? this.priceOptions[idx] : null,
        discountPercentage: this.discountPercentage,
        preparedRateDetails: this.preparedRateDetailsByTariff[idx] || null,
      });
    },
    emitIncrementTariffNotKoedia(tariff) {
      this.$emit('incrementTariff', {
        tariff,
        totalPrice: this.discountPercentage > 0
          ? parseFloat((parseFloat(this.calculateDailyTotalNotKoedia(tariff)) - this.getDiscountedAmount(parseFloat(this.calculateDailyTotalNotKoedia(tariff))) + this.safeFloat(this.houseHoldNotKoedia)).toFixed(2))
          : parseFloat((parseFloat(this.calculateDailyTotalNotKoedia(tariff)) + this.safeFloat(this.houseHoldNotKoedia)).toFixed(2)),
        pricePerNight: this.computedTariffPrices[tariff],
        cancellationConditions: Object.values(this.cancellationMessages).join(' ') || '',
        boardType: this.getBoardTypeNotKoedia(tariff) || '',
        htValueTotal: this.htValueTotalNotKoedia(tariff),
        tvalTotal: this.tvaValueTotalNotKoedia(tariff),
        taxTotal: this.taxValueTotal(),
        selectedPriceOptionFee: this.getSelectedPriceOptionFeeNotKoedia(tariff),
        houseHold: this.safeFloat(this.houseHoldNotKoedia),
        koediaRoomAvailability: this.roomAvailabilityNotKoedia,
        discountPercentage: this.discountPercentage,
      });
    },
    getTariffQty(idx) {
      // Return the quantity for this tariff from the tariffQtys prop passed by parent
      if (!this.isEntire && this.tariffQtys) {
        return this.tariffQtys[idx] || 0;
      }
      return 0;
    },
    maxQtyForTariff(idx) {
      // Get max quantity based on maxRoomQty prop (set by parent from stock/max_rooms_bookable)
      if (!this.isEntire) {
        return this.maxRoomQty || 1;
      }
      return 1;
    },
    // sendInfo() {
    //   this.$emit("sendInfo", this.item, this.numberOfRoom, this.total);
    // },
    isReserveProcessingForTariff(tariffKey) {
      return this.bookingInProgress && this.bookingInProgressKey === String(tariffKey);
    },
    emitSendInfoAndOpen(...payload) {
      this.$emit("sendInfo", ...payload);
      const reservationPath = '/reservation-hotel/' + this.lodging.slug + '/reservation/confirm';

      if (this.isPhone) {
        window.location.href = reservationPath;
        return;
      }

      window.open(reservationPath, '_blank');
    },
    findMatchingKoediaOption(options, fallbackOption, idx) {
      if (!Array.isArray(options) || options.length === 0) return null;

      const optionIndex = Number(idx);
      if (!fallbackOption) {
        if (Number.isInteger(optionIndex) && options[optionIndex]) {
          return options[optionIndex];
        }
        return options[0];
      }

      const fallbackRoomId = fallbackOption?.room_id ? String(fallbackOption.room_id) : null;
      if (fallbackRoomId) {
        const optionById = options.find((option) => this.getAvailabilityOptionRoomId(option) === fallbackRoomId);
        if (optionById) return optionById;
      }

      const optionBySignature = options.find((option) => {
        const sameTariff = String(option?.tariff ?? '') === String(fallbackOption?.tariff ?? '');
        const sameCancelFee = String(option?.tariff_cancel_feed ?? '') === String(fallbackOption?.tariff_cancel_feed ?? '');
        const sameBoardType = String(option?.board_type ?? '') === String(fallbackOption?.board_type ?? '');
        const sameRefundable = String(option?.refundable ?? '') === String(fallbackOption?.refundable ?? '');
        return sameTariff && sameCancelFee && sameBoardType && sameRefundable;
      });
      if (optionBySignature) return optionBySignature;

      const optionByTariff = options.find((option) => String(option?.tariff ?? '') === String(fallbackOption?.tariff ?? ''));
      if (optionByTariff) return optionByTariff;

      if (Number.isInteger(optionIndex) && options[optionIndex]) {
        return options[optionIndex];
      }

      return options[0];
    },
    findRoomAvailabilityForCurrentRoom(availabilities) {
      if (!Array.isArray(availabilities) || availabilities.length === 0) return null;

      const roomKoediaRoomId = this.item?.koedia_room_id ? String(this.item.koedia_room_id).trim() : '';
      if (roomKoediaRoomId) {
        const byId = availabilities.find((roomData) =>
          Array.isArray(roomData?.options) &&
          roomData.options.some((option) => this.getAvailabilityOptionRoomId(option) === roomKoediaRoomId)
        );

        if (byId) return byId;
      }

      const normalize = (value) => String(value || '').toLowerCase().trim();
      const roomNameCandidates = [
        this.item?.koedia_room_name,
        this.item?.name,
        this.normalizedRoomAvailability?.room_name,
      ]
        .map(normalize)
        .filter(Boolean);

      return availabilities.find((roomData) => roomNameCandidates.includes(normalize(roomData?.room_name))) || null;
    },
    async refreshKoediaSelectionForTariff(idx) {
      const fallbackOption = this.priceOptions && this.priceOptions[idx] ? this.priceOptions[idx] : null;

      if (!this.accomodationCode) {
        return {
          selectedOption: fallbackOption,
          koediaSessionId: this.koediaSessionId,
        };
      }

      try {
        const childAges = this.getReservationChildAges();
        const trackingId = ensureOspitaTrackingId();

        const response = await fetcher.post(`/lodgings/${this.lodging.slug}/get_availability`, {
          accommodation_code: this.accomodationCode,
          start: this.formatDateKoedia(this.koediaFrom),
          end: this.formatDateKoedia(this.koediaTo),
          adults: this.adults || 2,
          children_ages: childAges,
          room_count: 1,
          room_plans: [],
          ospita_tracking_id: trackingId,
        });

        const latestSessionId = response?.data?.koedia_session_id || this.koediaSessionId;
        this.updateReservationStateFromKoediaRefresh({ koediaSessionId: latestSessionId });
        const availabilities = Array.isArray(response?.data?.availabilities) ? response.data.availabilities : [];
        let roomAvailability = this.findRoomAvailabilityForCurrentRoom(availabilities);
        if (!roomAvailability && this.isEntire && availabilities.length > 0) {
          roomAvailability = availabilities[0];
        }

        const options = Array.isArray(roomAvailability?.options) ? roomAvailability.options : [];
        const selectedOption = this.findMatchingKoediaOption(options, fallbackOption, idx) || fallbackOption;

        return {
          selectedOption,
          koediaSessionId: latestSessionId,
        };
      } catch (error) {
        console.error('Failed to refresh Koedia availability before booking:', error);
        return {
          selectedOption: fallbackOption,
          koediaSessionId: this.koediaSessionId,
        };
      }
    },
    async sendInfo(idx) {
      if (this.bookingInProgress) return;
      if (this.emitOpenGuestModalIfNeeded()) return;

      this.bookingInProgress = true;
      this.bookingInProgressKey = String(idx);

      try {
        if (this.accomodationCode) {
          const refreshedSelection = await this.refreshKoediaSelectionForTariff(idx);
          const selectedOption = refreshedSelection?.selectedOption || (this.priceOptions && this.priceOptions[idx] ? this.priceOptions[idx] : null);
          const latestSessionId = refreshedSelection?.koediaSessionId || this.koediaSessionId;

          this.emitSendInfoAndOpen(
            this.item,
            this.pricePerNightTtc(idx),
            this.totalTtc(idx),
            selectedOption,
            idx,
            null,
            null,
            null,
            this.cancellationMessages[idx],
            this.boardType(idx),
            this.discountPercentage,
            latestSessionId,
          );
          return;
        }

        let options = null;
        try {
          const tariffKeys = idx?.split?.(',');
          options = tariffKeys
            .map(t => this.optionHash?.[t])
            .filter(val => val != null).join(', ');
        } catch (error) {
          options = null;
        }

        console.log('this.cancellationMessages', this.cancellationMessages)
        console.log('options', options)
        this.emitSendInfoAndOpen(
          this.item,
          this.computedTariffPrices[idx],
          this.calculateDailyTotalNotKoedia(idx),
          this.roomAvailabilityNotKoedia,
          idx,
          this.priceTvaNotKoedia(idx),
          this.priceHtNotKoedia(idx),
          this.houseHoldNotKoedia,
          this.cancellationMessages,
          options,
          this.discountPercentage,
          this.koediaSessionId,
        );
      } finally {
        this.bookingInProgress = false;
        this.bookingInProgressKey = null;
      }
    },
    formatDate(date) {
      let month = String(date.getMonth() + 1).padStart(2, "0");
      let day = String(date.getDate()).padStart(2, "0");
      let year = date.getFullYear();

      return year + "-" + month + "-" + day;
    },
    formatDateForKoedia(dateObj) {
      // Convert Date object to YYYY-MM-DD format
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    findPrice() {
      if (this.checkIn && this.checkOut && this.item.availabilities) {
        const dateCheckIn = this.item.availabilities.find(
          (el) => el.date === this.formatDate(this.checkIn)
        );
        const indexFrom = this.item.availabilities.indexOf(dateCheckIn);
        const dateCheckOut = this.item.availabilities.find(
          (el) => el.date === this.formatDate(this.checkOut)
        );
        const indexTo = this.item.availabilities.indexOf(dateCheckOut);

        const sum = this.item.availabilities
          .slice(indexFrom, indexTo + 1)
          .reduce((acc, current) => acc + current.pricing, 0);
        this.price = (sum / (indexTo - indexFrom + 1)).toFixed(2);
      }
      if (this.price) return this.price;
      else return this.item.pricing;
    },
    replaceYear(dateStr) {
      const d = new Date(dateStr);
      const baseYear = 2000; // use consistent base year
      return new Date(baseYear, d.getMonth(), d.getDate());
    },
    inRange(date, rangeStart, rangeEnd) {
      if (rangeStart <= rangeEnd) {
        return date >= rangeStart && date <= rangeEnd;
      } else {
        return date >= rangeStart || date <= rangeEnd;
      }
    },
    isDateRangeOverlapIgnoreYear(start, end, from, to) {
      const startDate = this.replaceYear(start);
      const endDate = this.replaceYear(end);
      const fromDate = this.replaceYear(from);
      const toDate = this.replaceYear(to);

      // If range crosses new year (e.g., Dec 15 to Jan 10), normalize
      const normalize = (s, e) => {
        return s <= e ? [s, e] : [s, new Date(2000, 11, 31), new Date(2000, 0, 1), e]; // Split around year end
      };

      const rangesA = normalize(startDate, endDate);
      const rangesB = normalize(fromDate, toDate);

      for (let i = 0; i < rangesA.length; i += 2) {
        const aStart = rangesA[i];
        const aEnd = rangesA[i + 1];
        for (let j = 0; j < rangesB.length; j += 2) {
          const bStart = rangesB[j];
          const bEnd = rangesB[j + 1];
          const overlap = aStart <= bEnd && bStart <= aEnd;
          if (overlap) return true;
        }
      }

      return false;
    },
    hasWeekdayInRange(startDateStr, endDateStr, targetDayIndex) {
      const start = new Date(startDateStr);
      const end = new Date(endDateStr);

      const current = new Date(start);
      while (current <= end) {
        if (current.getDay() === targetDayIndex) {

          console.log('Current Day', current.getDay())
        }
        if (current.getDay() === targetDayIndex) return true;
        current.setDate(current.getDate() + 1);
      }
      return false;
    },
    checkDiscountAvailable() {
      this.discountPercentage = 0;
      if (this.lodging.lodging_discounts?.length > 0) {
        let maxDiscount = 0;

        this.lodging.lodging_discounts.forEach((discount) => {
          const isInWeekRange = discount.offer_day !== null && discount.offer_day !== undefined
            ? this.hasWeekdayInRange(this.koediaFrom, this.koediaTo, discount.offer_day)
            : true;

          const isNightsValid =
            this.nights >= discount.min_stay_nights &&
            (discount.max_stay_nights ? this.nights <= discount.max_stay_nights : true);

          const isDateRangeValid = this.isDateRangeOverlapIgnoreYear(
            discount.start_date,
            discount.end_date,
            this.koediaFrom,
            this.koediaTo
          );

          if (isInWeekRange && isNightsValid && isDateRangeValid) {
            const parsedDiscount = parseInt(discount.discount_percent);
            if (parsedDiscount > maxDiscount) {
              maxDiscount = parsedDiscount;
              this.maxDiscountData = discount;
            }
          }
        });

        this.discountPercentage = maxDiscount;
      }
    },
    getDiscountedAmount(totalAmount) {
      if (totalAmount > 0 && this.discountPercentage > 0) {
        return (totalAmount * this.discountPercentage) / 100;
      }
    },
    // ─── Shared Koedia cancellation-policy helpers (mirrored from ReservationNewUserInfo) ───
    // These handle all fee_unit_type values including the five added in the Oct-2025 WSDL:
    //   booking_night | booking_day_checkout_incl | room_day_checkout_incl |
    //   pax_day_checkout_incl | days_as_x_pct
    // Also reads nights_percentage and apply_to_taxes tolerantly.

    _parseNumber(value, fallback = 0) {
      const n = Number(value);
      return Number.isFinite(n) ? n : fallback;
    },

    _getPolicyAttr(obj, key) {
      if (!obj || typeof obj !== 'object') return null;
      return obj[key] ?? obj[`@${key}`] ?? null;
    },

    _getPolicyRef(policy) {
      if (policy?.from_day && typeof policy.from_day === 'object') {
        return String(policy.from_day['@ref'] || 'before_checkin').toLowerCase();
      }
      return String(policy?.from_day_ref || policy?.ref || 'before_checkin').toLowerCase();
    },

    _getPolicyUnit(policy) {
      return (
        this._getPolicyAttr(policy, 'unit') ||
        this._getPolicyAttr(policy?.amount, 'unit') ||
        this._getPolicyAttr(policy?.percentage, 'unit') ||
        ''
      ).toString().toLowerCase().trim();
    },

    _getNightsPercentage(policy) {
      const val =
        this._getPolicyAttr(policy, 'nights_percentage') ||
        this._getPolicyAttr(policy?.percentage, 'nights_percentage') ||
        this._getPolicyAttr(policy?.amount, 'nights_percentage');
      const n = Number(val);
      return Number.isFinite(n) ? n : null;
    },

    // apply_to_taxes: read for tolerance; fee arithmetic remains server-side.
    // Returns true (spec default) when the attribute is absent.
    _getApplyToTaxes(policy) {
      const val = this._getPolicyAttr(policy, 'apply_to_taxes');
      if (val === null || val === undefined) return true;
      if (typeof val === 'boolean') return val;
      return String(val).trim().toLowerCase() !== 'false';
    },

    _selectBestPolicy(policies) {
      const beforeCheckin = policies.filter((p) => this._getPolicyRef(p) !== 'after_booking');
      return (beforeCheckin.length ? beforeCheckin : policies)
        .slice()
        .sort((a, b) => this._parseNumber(b?.to_day, -1) - this._parseNumber(a?.to_day, -1))[0] || null;
    },

    _formatToTime(rawToTime) {
      if (rawToTime === '0' || rawToTime === 0) return 'minuit';
      return rawToTime ? `${rawToTime} heures` : '';
    },

    _parseCancellationPolicyText(selectedPolicy, { toDay, fee, total } = {}) {
      if (!selectedPolicy) return '';

      const isFullyRefundable = toDay > 0;
      const toTime = this._formatToTime(selectedPolicy?.to_time);
      const unit = this._getPolicyUnit(selectedPolicy);
      const nightsPct = this._getNightsPercentage(selectedPolicy);

      // eslint-disable-next-line no-unused-vars
      const applyToTaxes = this._getApplyToTaxes(selectedPolicy);

      let refundablePercent = total > 0 ? Math.round(((total - fee) / total) * 100) : 0;
      refundablePercent = Math.max(0, Math.min(100, refundablePercent));

      if (unit === 'days_as_x_pct') {
        const nightsVal = this._parseNumber(
          selectedPolicy?.percentage?.['#text'] ??
          selectedPolicy?.percentage?.content ??
          selectedPolicy?.percentage ??
          selectedPolicy?.amount?.['#text'] ??
          selectedPolicy?.amount?.content ??
          selectedPolicy?.amount ??
          fee,
          0
        );
        const pctDisplay = nightsPct !== null ? nightsPct : 100;
        if (isFullyRefundable) {
          return toTime
            ? `Annulation gratuite jusqu'à ${toDay} jours avant l'arrivée (${toTime}) (puis frais de ${pctDisplay}% sur les ${nightsVal} premières nuits)`
            : `Annulation gratuite jusqu'à ${toDay} jours avant l'arrivée (puis frais de ${pctDisplay}% sur les ${nightsVal} premières nuits)`;
        }
        return toTime
          ? `Frais d'annulation de ${pctDisplay}% sur les ${nightsVal} premières nuits jusqu'à ${toDay} jours avant l'arrivée (${toTime})`
          : `Frais d'annulation de ${pctDisplay}% sur les ${nightsVal} premières nuits jusqu'à ${toDay} jours avant l'arrivée`;
      }

      if (['booking_night', 'booking_day_checkout_incl', 'room_day_checkout_incl', 'pax_day_checkout_incl'].includes(unit)) {
        if (isFullyRefundable) {
          return toTime
            ? `Annulation gratuite jusqu'à ${toDay} jours avant l'arrivée (${toTime})`
            : `Annulation gratuite jusqu'à ${toDay} jours avant l'arrivée`;
        }
        return toTime
          ? `Remboursable selon conditions de l'établissement jusqu'à ${toDay} jours avant l'arrivée (${toTime})`
          : `Remboursable selon conditions de l'établissement jusqu'à ${toDay} jours avant l'arrivée`;
      }

      if (isFullyRefundable) {
        return toTime
          ? `Annulation gratuite jusqu'à ${toDay} jours avant l'arrivée (${toTime})`
          : `Annulation gratuite jusqu'à ${toDay} jours avant l'arrivée`;
      }
      return toTime
        ? `Remboursable à hauteur de ${refundablePercent}% jusqu'à ${toDay} jours avant l'arrivée (${toTime})`
        : `Remboursable à hauteur de ${refundablePercent}% jusqu'à ${toDay} jours avant l'arrivée`;
    },

    // ─── End shared helpers ───────────────────────────────────────────────────

    buildCancellationItemsFromRateDetails(rateDetails, idx) {
      if (!rateDetails) return [];

      const refundableFlag = rateDetails?.rate_information?.refundable;
      const isRefundable =
        refundableFlag === true ||
        String(refundableFlag).toLowerCase() === 'true' ||
        String(refundableFlag) === '1';

      if (!isRefundable) return [];

      const rawPolicy = rateDetails?.cancellation_fees_policy;
      if (!rawPolicy) return [];

      const policies = (Array.isArray(rawPolicy) ? rawPolicy : [rawPolicy]).filter(Boolean);
      if (!policies.length) return [];

      const selectedPolicy = this._selectBestPolicy(policies);
      if (!selectedPolicy) return [];

      const toDay = this._parseNumber(selectedPolicy?.to_day, 0);
      const total = this._parseNumber(
        rateDetails?.rate_information?.total_price?.['@rack'],
        Number(this.totalTtc(idx)) || 0
      );
      const fee = this._parseNumber(selectedPolicy?.amount?.['@rack'], 0);

      const policyText = this._parseCancellationPolicyText(selectedPolicy, { toDay, fee, total });

      return policyText
        ? [
            policyText,
            "En cas d'annulation, après cette date, le paiement intégral de la réservation sera dû.",
          ]
        : [];
    },
    buildConditionsObject(idx, isKoedia = true) {
      const conditionsList = [];
      
      if (isKoedia) {
        // For Koedia accommodations
        const boardType = this.boardType(idx);
        if (boardType) conditionsList.push(boardType);
        
        const cancellationPolicy = this.cancellationMessages[idx];
        if (cancellationPolicy) conditionsList.push(cancellationPolicy);
        
        const weeklyRule = this.weeklyStayRuleLabel(idx);
        if (weeklyRule) conditionsList.push(weeklyRule);
      } else {
        // For non-Koedia accommodations
        const tariff = idx;
        const tariffKeys = tariff?.split?.(',') || [];
        const options = tariffKeys
          .map(t => this.optionHash?.[t])
          .filter(val => val != null);
        
        if (options.length > 0) {
          conditionsList.push(...options);
        }
        
        const cancellationPolicy = this.cancellationMessages[tariff];
        if (cancellationPolicy) conditionsList.push(cancellationPolicy);
        
        const weeklyRule = this.weeklyStayRuleLabel(tariff);
        if (weeklyRule) conditionsList.push(weeklyRule);
      }
      
      return conditionsList.length > 0 ? conditionsList.join(', ') : 'Non spécifié';
    },
    handleMakeRequest() {
      // Capture the current rate and number of people from the first available option
      if (this.priceOptions && this.priceOptions.length > 0) {
        const firstOption = this.priceOptions[0];
        const adults = parseInt(firstOption.adults) || 0;
        const children = parseInt(firstOption.children) || 0;
        this.currentNumberOfPeople = adults + children;
        this.currentSelectedRate = this.totalTtc(0);
        this.currentRatePerNight = this.pricePerNightTtc(0);
        this.currentConditions = this.buildConditionsObject(0, true);
        
        // Extract selectedPriceOptionFee from priceOptions for Koedia
        const selectedPriceOptionFee = firstOption?.tariff_cancel_feed || null;
        if (selectedPriceOptionFee) {
          this.currentConditions += `, Frais d'annulation: ${selectedPriceOptionFee}`;
        }
      } else if (this.roomAvailabilityNotKoedia && this.roomAvailabilityNotKoedia.length > 0 && this.tariffsNotKoedia && this.tariffsNotKoedia.length > 0) {
        // For non-Koedia accommodations
        const firstTariff = this.tariffsNotKoedia[0];
        this.currentNumberOfPeople = this.adults || 2;
        this.currentSelectedRate = this.calculateDailyTotalNotKoedia(firstTariff);
        this.currentRatePerNight = this.pricePerNightTtcNotKoedia(firstTariff);
        this.currentConditions = this.buildConditionsObject(firstTariff, false);
        
        // Extract selectedPriceOptionFee from roomAvailabilityNotKoedia for non-Koedia
        const selectedPriceOptionFee = this.roomAvailabilityNotKoedia?.find(el => el.tariff === firstTariff)?.tariff_cancel_feed || null;
        if (selectedPriceOptionFee) {
          this.currentConditions += `, Frais d'annulation: ${selectedPriceOptionFee}`;
        }
      }
      this.showVillaRequestForm = true;
      window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'click_info_villa',
            ecommerce: {
              number_of_people: parseInt(this.adults || 2),
              number_of_adult: this.adults || 0,
              number_of_child: 0,
              booking_window: 2,
              items: [{
                item_name: this.lodging.name,
                item_id: this.lodging.id,
                item_city: this.lodging.city ? this.lodging.city.name : 'Pruniers-en-Sologne',
                item_region: this.lodging && this.lodging.region ? this.lodging.region.name : 'Occitanie',
                item_category: 'Nos hébergements',
                item_variant: "hôtels",
              }]
            },
          });
    },
    handleRequestSubmitted() {
      this.showVillaRequestForm = false;
      this.$emit('make-request');
    }
  }
};
</script>

<style lang="scss" scoped>
.info-container.grid {
  display: grid;
  grid-template-columns: 1fr;
}

.reservation-container {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  gap: 0.5rem;
  scroll-behavior: smooth;
}

.reservation-card {
  width: 100%;
}

.reservation-box {
  width: 80%;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .info-container.grid.d-flex {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 20px;
  }

  .center {
    text-align: left;
    flex: 1;
  }
}

@media (max-width: 768px) {
  .info-container.d-flex {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }

  .center {
    text-align: left;
    flex: 1;
  }
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .reservation-container {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    gap: 1rem;
  }

  .villa-mobile-width .reservation-box {
    flex-shrink: 0;
  }
}

.reservation-card {
  width: 100%;
  margin: 0 auto;
}

.room-name {
  display: flex;

  .capacity {
    display: flex;
    align-items: center;
    margin-left: 1rem;
  }
}

.reservation-flex {
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
  will-change: transform;
  transform: translateZ(0);
}

.reservation-description {
  width: 100%;
  flex: 1 1 auto;

  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    .center {
      // text-align: center;

      p {
        font-size: 0.8rem;
        margin: 0;
      }
    }
  }

  .breakline {
    width: 100%;
    border-bottom: 1px solid black;
    text-align: right;
    cursor: pointer;

    img {
      width: 2%;
    }
  }
}

.hub-img-zoom {
  flex: 1 1 auto;
  position: relative;
  width: 100%;
  height: 362px;
  margin-right: 2rem;
  overflow: hidden;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;

  .hub-img {
    transition: transform 0.5s ease;
    object-fit: cover;
    height: 100%;
    width: 100%;
    aspect-ratio: 16/10;
  }

  .btn-galerie {
    bottom: 20px;
    right: 20px;
    width: 152px;
    z-index: 9999 !important;
    position: absolute !important;
    pointer-events: auto !important;
    cursor: pointer !important;

    .galerie-icon {
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 60px;
      padding: 1rem 2rem;
      color: white;
      width: 152px;
      height: 48px;
    }
  }

  .hub-img:hover {
    transform: scale(1.1);
  }
}

.box-price-two-col {
  grid-template-columns: repeat(2, 1fr);
}

.box-two-col {
  grid-column: 1 / 3;
}

.box-price-no-search {
  display: flex;
  justify-content: center;
  align-items: center;
}

.box-middle {
  margin: auto;
  padding: 10px;

  .taxes {
    background-color: #f7f7f7;
  }
}

.box-middle-three {
  margin: auto;
  padding: 10px;

  .taxes {
    background-color: #f7f7f7;
  }
}

.box-middle-two {
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  .taxes {
    background-color: #f7f7f7;
  }
}

.reservation-box {
  width: 100%;
  // height: 224px;
}

.green-inputer {
  background-color: $light-kaki;
  color: white;
  border: none;
  padding-left: 17px;
  width: 22%;
}

@media only screen and (max-width: 480px) {
  .box-middle-two {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    gap: 5px;
  }

  .box-middle {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  .box-middle-three {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding-left: 10px;
    flex-wrap: wrap;
  }

  .mobile-gridd {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    gap: 5px;
  }

  .box-middle p,
  .box-middle .taxes {
    flex: 1;
    margin: 0;
    padding: 8px;
  }

  .taxes {
    flex-basis: 100%;
    margin-top: 5px;
    text-align: left;
  }

  .mobile-member-section {
    margin-top: 1rem;
    text-align: center;
  }

  .member-btn {
    background-color: black;
    color: white;
    border: none;
    padding: 0.8rem;
    width: 100%;
    cursor: pointer;
    font: normal normal bold 12px/35px Raleway;
    letter-spacing: -0.12px;
    color: #FFFFFF;
    transition: background-color 0.3s, color 0.3s;
  }

  .member-btn.active {
    background-color: white;
    color: black;
    border: 1px solid black;
    font: normal normal bold 12px/35px Raleway;
    letter-spacing: -0.12px;
  }

  .member-menu {
    background-color: black;
    color: white;
    padding: 1rem;
    border-radius: 10px;
    margin-top: 1rem;
    text-align: left;
  }

  .member-menu h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .member-menu ul {
    list-style: none;
    padding: 0;
  }

  .member-menu ul li {
    margin-bottom: 0.5rem;
  }

  .member-menu .btn-member {
    display: block;
    width: 100%;
    background-color: white;
    color: black;
    border: none;
    padding: 0.8rem;
    font-size: 1rem;
    font-weight: bold;
    border-radius: 5px;
    margin-top: 1rem;
    cursor: pointer;
  }

}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .mobile-bullet {
    // padding-top: 0px !important;
    // padding-left: 0px !important;
    // padding-bottom: 0px !important;

  }

  .slider-container {
    position: relative;
    width: 100%;
    margin-top: 4.2vh;
    max-width: 800px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .slider {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .slider-image {
    width: 100%;
    height: 38vh;
    object-fit: cover;
    border-radius: 1px;
  }

  .arrow {
    position: absolute;
    top: 55%;
    transform: translateY(-50%);
    background-color: white;
    border: none;
    border-radius: 50%;
    width: 3.1rem;
    height: 3.1rem;
    cursor: pointer;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
  }


  .arrow:hover {
    opacity: 1;
  }

  .arrow-image {
    width: 0.7rem;
    height: auto;
  }

  .left-arrow {
    left: 2px;
  }

  .right-arrow {
    right: 2px;
  }



  .image-counter {
    position: absolute;
    bottom: 20px;
    right: 10px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 5px 10px;
    border-radius: 3px;
    font-size: 0.9rem;
    z-index: 10;
  }

  .show-more-btn {
    color: #3B6152;
  }

  .reservation-flex {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .reservation-description {
    width: 100%;

    .grid {
      display: flex;
      flex-direction: column;
    }

    .center {
      margin-top: 1rem;
    }
  }

  .hub-img-zoom {
    width: 100%;
    height: 224px;
    margin-right: 2rem;
    overflow: hidden;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  .box-price {
    display: flex;
    flex-direction: column;
  }

  .scrollable-gallery {
    overflow-x: auto;
    white-space: nowrap;
    padding: 1rem 0;
  }

  .image-scroll-wrapper {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding-left: 10px;
  }

  .scroll-image {
    width: 75vw;
    height: 38vh;
    object-fit: cover;
    border-radius: 6px;
    scroll-snap-align: start;
    flex-shrink: 0;
  }

  .info-container {
    padding: 1rem;
  }

  .room-details p {
    display: flex;
    align-items: center;
    font-size: 1rem;
    margin-bottom: 0.8rem;
  }

  .room-details i {
    margin-right: 8px;
    font-size: 1.1rem;
  }

  .equipments-title {
    font-weight: bold;
    font-size: 1.1rem;
    margin: 1.2rem 0 0.6rem;
  }

  .equipments-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px 12px;
  }

  .equipment-item {
    font-size: 0.95rem;
  }

  .icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    vertical-align: middle;
  }

}

.member-menu h2 {
  font: normal normal bold 22px/26px Raleway;
  color: #FFFFFF;

}

.member-menu p {
  font: normal normal normal 16px/29px Raleway;
  letter-spacing: -0.08px;
  color: #FFFFFF;

}

.member-menu ul {
  list-style: none;
  padding: 0;
  margin-bottom: 1.5rem;
  font: normal normal bold 16px/19px Raleway;
  letter-spacing: -0.16px;
  color: #FFFFFF;
}

.member-menu ul li {
  font-size: 1rem;
  margin-bottom: 0.5rem;
  font: normal normal bold 16px/19px Raleway;
  letter-spacing: -0.16px;
  color: #FFFFFF;
}

.already-member {
  font: normal normal normal 16px/29px Raleway;
  letter-spacing: -0.08px;
  color: #FFFFFF;
}

.already-member a {
  color: white;
  text-decoration: underline;
}

.already-member a:hover {
  text-decoration: none;
}

.note {
  font: normal normal normal 16px/29px Raleway;
  letter-spacing: -0.08px;
  color: #FFFFFF;
  line-height: 1.4;
  margin-top: 1rem;
}

.custom-tick-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.custom-tick-list li {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  font-size: 1rem;
  color: white;
}

.custom-tick-list li::before {
  content: "✔";
  font-size: 0.8rem;
  color: #3b6152;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: #ffffff;
  border-radius: 50%;
  margin-right: 10px;
  opacity: 1;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

._sub_title_right {
  color: white;
  font: normal normal bold 16px/32px Raleway;
  letter-spacing: 0px;
  text-transform: uppercase;
  opacity: 1;
}

._sub_title_right-two {
  font: normal normal 600 13px/15px Raleway;
  letter-spacing: 0px;
  text-transform: uppercase;
  display: none;
}

.delice-section {
  grid-column: 1 / -1;
  display: flex;
  // align-items: center;
  // justify-content: flex-start;
  height: 6vh;
  background-color: black;
  border-bottom: 1px solid #ddd;
}

.full-width {
  width: 100% !important;
}

.normal-width {
  width: 80%;
}


.reservation-container {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 0.5rem;
  scroll-behavior: smooth;
}

.reservation-box {
  flex: 0 0 auto;
  width: 100%;
  box-sizing: border-box;
}


.reservation-container.same-height .reservation-box {
  height: auto;
  /* Default height */
}

.reservation-box-content {
  flex-grow: 1;
  /* Ensures content stretches evenly */
}



.bullet-indicators {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.bullet {
  width: 10px;
  height: 10px;
  margin: 0 5px;
  border-radius: 50%;
  background-color: #ccc;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.bullet.active {
  background-color: #000;
}

.box-price {
  font-family: Arial, sans-serif;
  padding: 18px 16px 14px 21px;
  display: flex;
  flex-direction: column;
  font-family: $Raleway;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  border: unset;

  @media (max-width: 600px) {
    padding: 12px 10px 10px 12px;
  }
}

.conditions {
  padding-top: 2px;
  text-align: left !important;
}

.conditions p {
  margin: 4px 0;
  color: #000;
  font: normal normal 600 13px/15px Raleway;
}

.pricing-section {
  display: flex;
  flex-direction: column;
  font-family: $Raleway;
}

.price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 4px 0;
  font-family: $Raleway;
}

.price-row.total {
  font-weight: bold;
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 3px;
  padding-bottom: 3px;
  font-family: $Raleway;
}

.price-row.total-two {
  font-weight: bold;
  display: flex;
  flex-direction: column;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 3px;
  padding-bottom: 3px;
  font-family: $Raleway;
}

.total-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.price-note {
  font-size: 14px;
  color: #555;
  text-align: left;
  width: 100%;
  font-family: $Raleway;
  font-style: italic;
}

.price-row.totall {
  // font-weight: bold;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  font-family: $Raleway;

  .hortense-btn-primary {
    @media screen and (max-width: 600px) {
      height: 40px !important;
    }
  }
}

.hortense-btn-primary {
  color: #fff;
  padding: 16px 36px;
  border: none;
  text-align: center;
  cursor: pointer;
  width: 100%;
}

.hortense-btn-primary:hover {
  background-color: #1d4537;
}

.hortense-btn-secondary {
  background-color: white;
  color: #2C5E4B;
  border: 1px solid #2C5E4B;
  padding: 16px 36px;
  text-align: center;
  cursor: pointer;
  font-weight: bold;
  font-size: 13px;
  transition: all 0.3s ease;

  @media screen and (max-width: 768px) {
    padding: 16px 10px;
    height: 6vh;
  }

  @media screen and (min-width: 768px) and (max-width: 1300px) {
    padding: 16px 1rem;
  }

  @media screen and (max-width: 390px) {
    padding: 5px;
  }

  @media screen and (max-width: 375px) {
    padding: 2px;
  }
}

.hortense-btn-secondary:hover {
  background-color: #f5f5f5;
  border-color: #1d4537;
  color: #1d4537;
}

.button-container {
  display: flex;
  justify-content: center;
  padding: 8px;
}

.gap-2 {
  gap: 12px;
}

.gap-1 {
  gap: 5px;
}

.conditions {
  margin-bottom: 2px;
}

.pricing-section {
  margin-bottom: 1px;
}

@media (max-width: 600px) {
  .box-price {
    font-family: Arial, sans-serif;
    max-width: 400px;
    margin: 16px auto;
    display: flex;
    flex-direction: column;
    font-family: $Raleway;
  }

  .conditions {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 2px;
    text-align: left !important;

    @media screen and (max-width: 600px) {
      padding-left: 0;
      padding-right: 0;
    }
  }

  .conditions p {
    margin: 4px 0;
    color: #000;
    font-family: $Raleway;
  }

  .pricing-section {
    display: flex;
    flex-direction: column;
    font-family: $Raleway;
  }

  .price-row {
    display: flex;
    justify-content: space-between;
    margin: 4px 0;
    font-family: $Raleway;
  }

  .price-row.total {
    font-weight: bold;
    border-top: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    background-color: #f7f7f7;
    padding-left: 12px;
    padding-right: 12px;
    border-radius: 4px;
    font-family: $Raleway;

    @media screen and (max-width: 600px) {
      padding-left: 5px;
      padding-right: 0;
    }

    .hortense-btn-primary {
      @media screen and (max-width: 600px) {
        height: 40px !important;
      }
    }
  }

  .price-row.totall {
    // font-weight: bold;
    display: flex;
    justify-content: space-between;
    padding-left: 12px;
    padding-right: 12px;
    font-family: $Raleway;
  }

  .price-note {
    font-size: 14px;
    color: #555;
    text-align: left;
    font-family: $Raleway;
  }

  .hortense-btn-primary {
    background-color: #2c5e4b;
    color: #fff;
    padding: 10px 16px;
    border: none;
    text-align: center;
    cursor: pointer;
    width: 100%;
  }

  .hortense-btn-primary:hover {
    background-color: #1d4537;
  }

  .button-container {
    display: flex;
    justify-content: center;
    padding: 8px;
  }

  .conditions {
    margin-bottom: 2px;
  }

  .pricing-section {
    margin-bottom: 1px;
  }

}

.tariff-slider-wrapper {
  width: 100%;
}

.tariff-slider {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 5px;
  row-gap: 10px;
  padding: 1rem 0;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: unset;
  }
}

.arrow {
  position: absolute;
  top: 3.5%;
  transform: translateY(-50%);
  background: white;
  border: none;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  font-size: 1.5rem;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.arrow.left {
  // left: -15px;
}

.arrow.right {
  right: 0px;
}

.discount-percentage {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px;
  gap: 10px;
  width: 30px;
  height: 18px;
  background: #CFE5DC;
  border-radius: 10px;
}

.reservation-flex-img-cont {
  width: 65%;
  height: fit-content;
}

.full-width-reser-cont {
  .box-price {
    margin: 16px 16px 16px 0;
  }

  .box-price-no-search {
    margin: 16px auto !important;
  }

  .reservation-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
    max-width: 100%;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .reservation-box {
    width: 100%;
  }
}

.text-light-gray {
  color: #707070;
}

.tariff-qty-control {
  .qty-btn {
    background: #f0f0f0;
    border: 1px solid #ddd;
    border-radius: 4px;
    width: 32px;
    height: 32px;
    padding: 0;
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
    color: #2C5E4B;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
      background: #2C5E4B;
      color: white;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .qty-value {
    font-weight: 600;
    min-width: 30px;
    text-align: center;
  }
}

@media screen and (max-width: 768px) {
  .total-content {
    .hortense-btn-primary {
      height: 40px !important;
    }
  }
}

.villa-form-inline-container {
  width: 100%;
  background: white;
  padding: 1rem;
}

</style>
